// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"cdca2c2c","585":"2ff7fa7d"}[chunkId] + ".chunk.js";
};